import React from 'react';
import { Redirect } from 'react-router-dom';
import withSplashMessage from '../splashMessage/withSplashMessage';
import DetailsBar from '../shared/DetailsBar';
import Loader from '../shared/Loader';
import HeadingPlaceholder from '../shared/HeadingPlaceholder';
import SelectedDishes from '../shared/SelectedDishes';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import {
  maskPhone,
  maskPrependComma,
  maskServiceDate,
  maskServiceEndTime,
  maskServiceStartTime,
  maskSlug,
  serviceTypeSwitch,
  maskCapitalizeFirstLetter
} from '../../masks';
import { stringfyServerErrors } from '../../helpers/util';
import TextAreaView from '../shared/TextAreaView';
import { chefAPI } from '../../InterfaceAPI/chefAPI';
import ChefDeclineOpportunityModal from './ChefDeclineOpportunityModal';
import ModalEnabled from '../extend/ModalEnabled';
import BackButton from '../shared/BackButton';
import { isOccasion } from '../../helpers/serviceUtil';

class ChefService extends ModalEnabled {
  detailsBarProperties = [
    {
      label: 'Service Date & Time',
      className: 'p',
      combine: [
        { key: 'date', mask: maskServiceDate },
        { raw: ' ', className: '--new-line' },
        { key: 'start_time', mask: maskServiceStartTime },
        { key: 'end_time', mask: maskServiceEndTime }
      ]
    },
    {
      label: 'Address',
      className: 'p',
      key: 'address',
      combine: [
        { key: 'street_address' },
        { key: 'street_address_continued', mask: maskPrependComma },
        { raw: ' ', className: '--new-line' },
        { key: 'city' },
        { key: 'state', mask: maskPrependComma },
        { raw: ' ' },
        { key: 'zip_code' }
      ]
    },
    {
      label: 'Client',
      key: 'client',
      combine: [
        { key: 'name' },
        { raw: ' ', className: '--new-line' },
        {
          link: {
            to: 'tel:[phone_number]',
            advancedLabel: { key: 'phone_number', mask: maskPhone },
            crossOrigin: true
          }
        }
      ]
    },
    {
      label: 'Diet',
      key: 'client',
      combine: [{ key: 'dietary_preference_tags', dive: 'tag' }]
    },
    {
      label: 'Allergens',
      key: 'client',
      combine: [
        { key: 'allergen_tags', dive: 'tag' },
        { key: 'other_allergens', mask: maskPrependComma }
      ]
    },
    {
      label: 'Portion',
      key: 'client',
      combine: [{ key: 'portion_size', mask: maskCapitalizeFirstLetter }]
    },
    {
      label: 'Guests',
      key: 'guest_number',
      labelClass: 'guests-number'
    }
  ];

  state = {
    service: {},
    isDownload: false,
    isLoading: false
  };

  render() {
    const { service, isDownloading, isLoading } = this.state;
    const { client = {} } = service;
    const { client_101 = '' } = client;

    if (isLoading) return <Loader />;

    if (this.state.redirect_to) return <Redirect to={this.state.redirect_to} />;

    return (
      <div className="cms cms--public">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <BackButton defaultUrl="/" />
            <div className="cms__bar cms__bar--wrap">
              <div className="cms__user-heading">
                <HeadingPlaceholder
                  value={service.name}
                  label={serviceTypeSwitch(service.service_type)}
                />
              </div>
              <div className="cms__bar-ctas">
                {service.id && (
                  <input
                    type="button"
                    className="cms__bar-cta btn btn--solid-blue"
                    value="Download Chef Materials"
                    onClick={this.downloadChefMaterials}
                    disabled={isDownloading}
                  />
                )}
              </div>
            </div>

            {this.renderDetailsBar()}
          </div>
        </div>

        <div className="cms__body">
          <div className="cms__content">
            <div className="row">
              <SelectedDishes
                instructions={service.special_instructions}
                menuSelections={service.menu_selections}
                notes={service.notes}
              />
            </div>
            <div className="row">
              <div className="row__item row__item--half">
                <TextAreaView
                  title="Client 101"
                  isEdit={false}
                  value={client_101}
                />
              </div>
            </div>

            {service.id && (
              <div className="row">
                <button
                  type="button"
                  className="btn btn--hollow-red"
                  onClick={() => this.openModal('decline-service')}
                >
                  Drop Service
                </button>
              </div>
            )}
          </div>
        </div>

        {this.isOpen('decline-service') && (
          <ChefDeclineOpportunityModal
            isOpen={this.isOpen('decline-service')}
            closeModal={this.closeModal}
            opportunity={{ service }}
            onSubmit={this.handleDeclineService}
          />
        )}
      </div>
    );
  }

  loadService(id) {
    this.setState({ isLoading: true });
    serviceAPI
      .getService(id)
      .then(service => this.setState({ service, isLoading: false }))
      .catch(this.handleErrorLoading);
  }

  downloadChefMaterials = () => {
    const { id, name, date } = this.state.service;
    const filename = `materials-${maskSlug(name)}-${date}.pdf`;
    this.setState({ isDownloading: true });

    console.log(filename, 'FIlter name');

    serviceAPI
      .downloadChefMaterials(id, filename)
      .then(success => {
        this.setState({ isDownloading: false });
        this.props.addMessage({
          className: 'success',
          message: 'Chef Materials Successfully Downloaded'
        });
      })

      .catch(error => {
        this.setState({ isDownloading: false });
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(error)
        });
      });
  };

  handleDeclineService = () => {
    const { user } = this.props;
    const { id: chefID = 0 } = user;
    const { id: serviceID = 0 } = this.state.service;

    if (chefID > 0 && serviceID > 0) {
      chefAPI
        .declineService(chefID, serviceID)
        .then(response => {
          this.props.addMessage({
            className: 'success',
            message: `Service has been declined.`
          });
          this.setState({ redirect_to: '/' });
        })
        .catch(err => {
          this.props.addMessage({
            className: 'error',
            message: stringfyServerErrors(err)
          });
          this.closeModal();
        });
    }
  };

  handleErrorLoading = error => {
    console.log(error);
    const pathname = '/';
    const redirect_to = { pathname };

    const { state } = this.props.location;
    if (state) {
      const { redirect_url, redirect_payload } = state;
      if (redirect_url) {
        redirect_to.pathname = redirect_url;
      }

      if (redirect_payload) redirect_to.state = { ...redirect_payload };
    }
    this.props.addMessage({
      className: 'error',
      message: stringfyServerErrors(error)
    }); // todo: add messaging
    this.setState({ redirect_to, isLoading: false });
  };

  renderDetailsBar() {
    const { service } = this.state;
    let className = 'chef-service__details-bar';
    if (
      service &&
      service.service_type &&
      isOccasion(service)
    ) {
      className += ' chef-service__details-bar--show-guests';
    }
    return (
      <DetailsBar
        data={service}
        columns={this.detailsBarProperties}
        className={className}
      />
    );
  }

  componentDidMount() {
    // todo: remove this temporary logic
    // temporary dev logic: allow admin to load this page for any user
    const { id = 0 } = this.props.match.params;
    console.log(id);
    if (id && id > 0) {
      this.loadService(id);
    }
  }
}
export default withSplashMessage(ChefService);



// WEBPACK FOOTER //
// ./src/components/chef/ChefService.js